<template>
	<PublicPage current="/payment-types" eyebrow="PAYMENT TYPES" :title="['What\'s on', 'your list?']" lead="Eleven real-life reasons to make a payment — the ones that usually happen away from a checkout counter.">
		<div class="article-intro">
			<span>A BIGGER WORLD OF PAYMENTS</span>
			<h2>One place for the payments behind real life.</h2>
			<p>Rent, education, a deposit for your next space, or the people who get things done. Choose the purpose that fits, review every detail and keep the record in one place.</p>
		</div>
		<ContentSection v-for="(group, i) in grouped" :key="group.name" :number="String(i + 1).padStart(2, '0')" :title="group.name">
			<div class="payment-directory public-directory">
				<a v-for="item in group.items" :key="item.name" class="directory-item" :href="registerUrl">
					<span class="directory-number">{{ String(categories.indexOf(item) + 1).padStart(2, "0") }}</span>
					<span class="directory-icon"><component :is="item.icon" :size="22" :stroke-width="1.7" /></span>
					<span class="directory-copy"><strong>{{ item.name }}</strong><small>{{ item.detail }}</small></span>
					<ArrowUpRight :size="19" class="directory-arrow" aria-hidden="true" />
				</a>
			</div>
		</ContentSection>
		<ContentSection :number="String(grouped.length + 1).padStart(2, '0')" title="Before you pay">
			<p>Payment availability and eligibility depend on the recipient, the payment purpose and applicable terms. Keep the recipient's correct details, your payment purpose and the amount ready, and review everything before you confirm.</p>
			<PdArrowLink class="article-link-pd" href="/how-it-works" underline>See how it works</PdArrowLink>
		</ContentSection>
	</PublicPage>
</template>

<script setup>
import { ArrowUpRight } from "lucide-vue-next";
import PdArrowLink from "@paydeck-ui/components/PdArrowLink.vue";
import PublicPage from "@/components/site/PublicPage.vue";
import ContentSection from "@/components/site/ContentSection.vue";
import { categories, groups } from "@/content/home";
import { registerUrl } from "@/content/site";

const grouped = groups.slice(1).map((name) => ({ name, items: categories.filter((item) => item.group === name) }));
</script>
